import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getESignUrl } from "../utils/urlHelper";

const eSignApi = createApi({
  reducerPath: "eSign",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    fetchESignDoc: builder.mutation({
      query: (body) => ({
        url: getESignUrl("fetch_e_sign_doc"),
        method: "POST",
        body,
      }),
    }),
    sendOtp: builder.mutation({
      query: (body) => ({
        url: getESignUrl("send1_otp_crosssell"),
        method: "POST",
        body,
      }),
    }),
    verifyOtp: builder.mutation({
      query: (body) => ({
        url: getESignUrl("validate_otp_crosssell"),
        method: "POST",
        body,
      }),
    }),
    eSignDoc: builder.query({
      query: ({ name, email, phone }) => ({
        url: getESignUrl(`e_sign?name=${name}&email=${email}&phone=${phone}`),
        method: "POST",
      }),
    }),
    eSignKFS: builder.mutation({
      query: (body) => ({
        url: getESignUrl("e_sign/kfs"),
        method: "POST",
        body,
      }),
      transformResponse: (response, meta) => {
        response.statusCode = meta?.response?.status;
        return response;
      },
    }),
    eSignDisburse: builder.mutation({
      query: (body) => ({
        url: getESignUrl("disburse"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useFetchESignDocMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useESignDocQuery,
  useESignDisburseMutation,
  useESignKFSMutation,
} = eSignApi;

export { eSignApi };
